<template>
  <HXContentCard
    :title="
      cargaHabilitadaActiva && tiempoRestante
        ? ''
        : 'Cargar documentos de cuenta de cobro'
    "
    :defaultToBack="!showInit"
  >
    <!-- Cuenta regresiva en header -->
    <template #title v-if="cargaHabilitadaActiva && tiempoRestante">
      <div class="d-flex align-items-center">
        <span class="mr-2 font-weight-bold"
          >Cargar documentos de cuenta de cobro</span
        >
        <div
          class="countdown-header"
          v-b-tooltip.hover
          title="Tiempo restante para cerrar la carga"
        >
          <i class="ti ti-clock mr-1 text-white-50" style="font-size: 1rem"></i>
          <span class="countdown-text">
            {{ tiempoRestante.dias }}d {{ tiempoRestante.horas }}h
            {{ tiempoRestante.minutos }}m {{ tiempoRestante.segundos }}s
          </span>
        </div>
      </div>
    </template>
    <!-- lista periodos -->
    <section class="row p-3">
      <div class="col-12 col-md-4">
        <label class="form-label">
          <i class="ti ti-calendar-month"></i>
          Período de facturación:
        </label>
        <!-- vue-select -->
        <div style="background: transparent; padding: 0rem">
          <v-select
            class="style-chooser"
            :options="periodos"
            :get-option-label="
              (option) =>
                `${$moment(option.Periodo, 'YYYY-MM').format('MMMM, YYYY')} - ${
                  option.Estado == 1 ? 'Completado' : 'Pendiente'
                }`
            "
            @input="updateSelectedIdx"
            v-model="selectedValue"
            placeholder="Selecciona el período..."
          >
            <!-- sin resultados en la búsqueda -->
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                No se encontraron períodos para
                <b class="text-white-50">{{ search }}</b
                >.
              </template>
              <b v-else style="opacity: 0.5">No hay períodos disponibles.</b>
            </template>
          </v-select>
        </div>
      </div>
      <div style="justify-content: center">
        <vs-button
          class="mt-4"
          icon
          color="#0b8f8d"
          v-b-tooltip.hover
          title="Configurar retención en la fuente"
          @click="retencionEnLaFuenteModal()"
        >
          Configurar retención en la fuente
        </vs-button>
      </div>
    </section>

    <div class="p-4">
      <!-- Información -->
      <div class="d-flex flex-column align-items-center">
        <!-- estado -->
        <vs-button
          class="lego-badge"
          icon
          active
          :danger="!cargaHabilitadaActiva"
          :success="cargaHabilitadaActiva"
          style="cursor: default"
        >
          <i
            :class="`ti ti-${
              cargaHabilitadaActiva ? 'lock-open-2' : 'lock'
            } mr-1`"
          ></i>
          {{ cargaHabilitadaActiva ? "Carga habilitada" : "Carga cerrada" }}
        </vs-button>

        <p class="text-center mt-2">
          <i class="ti ti-info-circle mr-1" style="font-size: 1rem"></i>
          <b>Atención:</b>
          El plazo para cargar documentos finaliza el
          {{
            fechaCargaHabilitada && fechaCargaHabilitada.fechaFin
              ? $moment(fechaCargaHabilitada.fechaFin).format(
                  "DD/MM/YYYY hh:mm a"
                )
              : ""
          }}
        </p>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="mt-2" v-for="(item, index) in itemsFiles" :key="index">
            <template v-if="item.visible">
              <div class="row bg-dark rounded pointer">
                <div
                  class="col-12 col-md rounded bg-dark py-3 px-2"
                  @click="toggle(index)"
                >
                  <div>
                    <i
                      class="mr-2"
                      :class="[
                        'fas',
                        isActive(index)
                          ? 'fa-chevron-down'
                          : 'fa-chevron-right',
                      ]"
                    ></i>
                    <span>{{ item.title }}</span>
                  </div>
                </div>
                <div
                  class="col-12 col-md d-flex align-items-center justify-content-md-end px-2"
                  v-if="item.url"
                >
                  <!-- Soporte modificado -->
                  <div
                    class="file-modify-badge"
                    v-if="item.estado == -1"
                    v-b-tooltip.hover
                    title="Documento actualizado"
                  >
                    <i class="ti ti-file-upload" style="font-size: 1.2rem"></i>
                  </div>
                  <!-- Badge estado gestión -->
                  <vs-button
                    v-b-tooltip.hover
                    :title="
                      item.estado == 1
                        ? 'Documento aprobado por auditoría'
                        : item.estado == 0
                        ? 'Documento rechazado por auditoría'
                        : 'Documento en revisión por auditoría'
                    "
                    class="lego-badge"
                    icon
                    transparent
                    active
                    size="mini"
                    :danger="item.estado == 0"
                    :success="item.estado == 1"
                    :warn="item.estado == -1 || item.estado == null"
                    style="cursor: default"
                  >
                    <i
                      :class="`ti ti-${
                        item.estado == 1
                          ? 'file-like'
                          : item.estado == 0
                          ? 'file-dislike'
                          : 'file-time'
                      } mr-1`"
                    ></i>
                    {{
                      item.estado == 1
                        ? "Aprobado"
                        : item.estado == 0
                        ? "Rechazado"
                        : "En revisión"
                    }}
                  </vs-button>
                  <!-- Acciones -->
                  <vs-button
                    transparent
                    icon
                    v-b-tooltip.hover
                    title="Ver documento"
                    @click="gotoFile(item.url)"
                  >
                    <i class="ti ti-eye text-white-50"></i>
                  </vs-button>
                  <vs-button transparent icon @click="toggleComponent(index)">
                    <i
                      v-b-tooltip.hover
                      :title="
                        showDivs[index] ? 'Ver comentarios' : 'Cargar documento'
                      "
                      :class="
                        showDivs[index]
                          ? 'ti ti-message text-white-50'
                          : 'ti ti-file-text text-white-50'
                      "
                    ></i>
                  </vs-button>
                </div>
              </div>
              <transition name="slide" appear>
                <div
                  v-show="isActive(index)"
                  class="accordion-content mx-1 mt-2"
                >
                  <div class="row mb-2" style="gap: 0.5rem">
                    <div class="col-12 col-md-3" v-if="item.formatoSugerido">
                      <b-link
                        v-show="item.formatoSugerido"
                        :href="item.formatoSugerido"
                        class="d-flex align-items-center"
                      >
                        <i class="ti ti-download mr-1"></i>
                        Descargar formato
                      </b-link>
                    </div>
                    <div
                      v-if="item.url"
                      class="col-12 col-md d-flex flex-wrap justify-content-md-end"
                    >
                      <span class="mx-2">
                        <i class="ti ti-calendar-event"></i>
                        Cargado:
                        {{ item.fechaSubida | moment("from", "now") }}
                      </span>
                      <span class="mx-2" v-if="item.fechaEstado">
                        <i class="ti ti-calendar-check"></i>
                        Revisado:
                        {{ item.fechaEstado | moment("from", "now") }}
                      </span>
                    </div>
                  </div>
                  <transition name="fade" mode="out-in">
                    <DropFile
                      v-if="showDivs[index]"
                      :key="`dropfile-${index}`"
                      :id="index + 1"
                      :archivo="{
                        Id: item.id,
                        PersonaId: personaId,
                        NombreArchivo: item.name,
                        UrlArchivo: item.url,
                        FechaSubida: item.fechaSubida,
                        EstadoGestion: item.estado,
                      }"
                      :urlDir="`users/${personaId}/CDC/${currentPeriod.mes}/`"
                      :injectData="{
                        PersonaId: personaId,
                        NombreArchivo: item.name,
                        UrlArchivo: `https://helexiumfiles.com/users/${personaId}/CDC/${currentPeriod.mes}/`,
                        FechaSubida: $moment
                          .tz(new Date(), 'America/Bogota')
                          .format('YYYY-MM-DDTHH:mm:ss'),
                        PeriodoReferencia: selectedValue.Periodo,
                      }"
                      :fileTypes="['application/pdf']"
                      :cargaHabilitada="cargaHabilitadaActiva"
                    />
                    <ComentariosCuentaCobro
                      v-else
                      :key="`comentarios-${index}`"
                      :dataSendCommentFile="buildObjectCommentFile(item.id)"
                      :commentsFiles="item.comments"
                      :cargaHabilitada="cargaHabilitadaActiva"
                      class="div-comentario-v2"
                    />
                  </transition>
                </div>
              </transition>
            </template>
          </div>
        </div>
      </div>
      <div
        v-if="cargaHabilitadaActiva"
        :class="`fixed-bottom-button ${
          habilitarCarga ? 'border-animation' : ''
        }`"
      >
        <span> </span>
        <span> </span>
        <span> </span>
        <span> </span>
        <vs-button
          icon
          @click="guardarArchivos()"
          :disabled="!habilitarCarga"
          size="medium"
          :loading="waiting"
        >
          <i class="ti ti-cloud-up mr-2" style="font-size: 1.5rem"></i>
          Cargar documentos
        </vs-button>
      </div>
    </div>
    <!--retención en la fuente -->
    <b-modal
      id="modal-retencion"
      :title="`Configuración de retención en la fuente`"
      size="md"
      hide-footer
    >
      <form ref="fromretencion" @submit.prevent="guardarRetencionEnLaFuente">
        <div class="row px-2">
          <div class="col-12 py-2 rounded">
            <div class="row m-3">
              <div class="col-6 px-0">
                <h4 class="mb-2"><b>Mes:</b></h4>
                <b-select
                  v-model="currentPeriod.mes"
                  class="form-control personalizado"
                  disabled
                  :options="listaMes"
                  text-field="text"
                  value-field="id"
                  required
                />
              </div>
              <div class="col-3 px-1">
                <h4 class="mb-2"><b>Año:</b></h4>
                <b-select
                  disabled
                  v-model="currentPeriod.anio"
                  class="form-control personalizado"
                  :options="listaAnios"
                  required
                />
              </div>
              <div class="col-3 px-1">
                <h4 class="mb-2"><b>Artículo:</b></h4>
                <b-select
                  v-model="articuloSeleccionado"
                  class="form-control personalizado"
                  :options="listaArticulos"
                  required
                />
              </div>
            </div>
            <div class="px-0 mt-3 d-flex justify-content-end">
              <vs-button
                danger
                class="px-2 py-1"
                @click.prevent="$root.$bvModal.hide('modal-retencion')"
                id="sendform2"
              >
                Cancelar
              </vs-button>
              <vs-button primary class="px-2 py-1" type="submit" id="sendform3">
                Guardar configuración
              </vs-button>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </HXContentCard>
</template>

<script>
import Swal from "sweetalert2";
import ComentariosCuentaCobro from "../../../components/ComentariosCuentaCobro/ComentariosCuentaCobro.vue";
import { eventBus } from "../../../main";
import DropFile from "@/components/helexium/DropFileCDC.vue";
import { core } from "../../../config/pluginInit";

export default {
  components: {
    DropFile,
    ComentariosCuentaCobro,
  },
  data() {
    return {
      timeout: null,
      selectedIdx: 0,
      selectedValue: null,
      fechaCargaHabilitada: null,
      personaId: null,
      showDivs: {},
      activeIndexes: [],
      persona: {},
      periodos: [],
      tiempoRestante: null,
      countdownInterval: null,
      itemsFiles: [
        {
          id: "",
          title: "Cuenta de cobro (formato oficial)",
          name: "Cuenta_de_cobro",
          url: "",
          estado: null,
          fechaEstado: "",
          fechaSubida: "",
          comments: [],
          formatoSugerido:
            "https://helexiumfiles.com/documentos/Formato-sugerido-cuenta-cobro.docx",
          visible: false,
        },
        {
          id: "",
          title: "Declaración juramentada de ingresos",
          name: "Declaracion_juramentada",
          url: "",
          estado: null,
          fechaEstado: "",
          fechaSubida: "",
          comments: [],
          formatoSugerido:
            "https://helexiumfiles.com/documentos/Formato-sugerido-declaracion-juramentada.docx",
          visible: true,
        },
        {
          id: "",
          title: "Planilla de seguridad social (EPS/ARL)",
          name: "Planilla_de_seguridad_social",
          url: "",
          estado: null,
          fechaEstado: "",
          fechaSubida: "",
          comments: [],
          visible: true,
        },
        {
          id: "",
          title: "Póliza de responsabilidad civil",
          name: "Poliza",
          url: "",
          estado: null,
          fechaEstado: "",
          fechaSubida: "",
          comments: [],
          visible: true,
        },
        {
          id: "",
          title: "Comprobante de pago de la póliza",
          name: "Recibo_de_pago_de_la_poliza",
          url: "",
          estado: null,
          fechaEstado: "",
          fechaSubida: "",
          comments: [],
          visible: true,
        },
      ],
      waiting: false,
      listaArchivos: [],
      archivosCargados: [],
      archivosSubidos: [],
      archivosReSubidos: [],
      horaActual: this.$moment().tz("America/Bogota"),
      articuloSeleccionado: null,
      personaRetencionEnLaFuente: null,
      historialRetencion: [],
      listaAnios: [2025, 2026, 2027],
      listaArticulos: [383, 392],
      listaMes: [
        { id: 1, text: "Enero" },
        { id: 2, text: "Febrero" },
        { id: 3, text: "Marzo" },
        { id: 4, text: "Abril" },
        { id: 5, text: "Mayo" },
        { id: 6, text: "Junio" },
        { id: 7, text: "Julio" },
        { id: 8, text: "Agosto" },
        { id: 9, text: "Septiembre" },
        { id: 10, text: "Octubre" },
        { id: 11, text: "Noviembre" },
        { id: 12, text: "Diciembre" },
      ],
      rentencionPeriodo: false,
      archivosParaBatch: [],
    };
  },
  watch: {
    async selectedValue(newValue) {
      console.log("selectedValue", newValue);

      if (newValue) {
        // Limpiar archivos cargados al cambiar de período
        this.cleanArchivosCargados();

        await this.getFechaHabilitadaCargaSoportes(
          this.currentPeriod.anio,
          this.currentPeriod.mes
        );

        await this.getPeriodFiles(
          this.currentPeriod.anio,
          this.currentPeriod.mes
        );
      }
    },
  },
  async mounted() {
    this.personaId = this.$route.params.id;
    this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
    if (!this.personaId) this.personaId = this.persona.id;

    this.intervalHora = setInterval(() => {
      this.horaActual = this.$moment().tz("America/Bogota");
    }, 60000);

    // Iniciar cuenta regresiva
    this.iniciarCuentaRegresiva();

    await this.getPeriodos();
    this.initializeShowDivs();
    core.index();
    this.HistorialretencionEnLaFuente();

    eventBus.$on("archivosSubidos", this.handleArchivosSubidos);
    eventBus.$on("archivoCargado", this.handleArchivoCargado);
    eventBus.$on("archivoNoValido", this.handleArchivoNoValido);
    eventBus.$on(
      "archivoProcesadoParaBatch",
      this.handleArchivoProcesadoParaBatch
    );
  },
  beforeDestroy() {
    if (this.intervalHora) clearInterval(this.intervalHora);
    if (this.countdownInterval) clearInterval(this.countdownInterval);

    eventBus.$off("archivosSubidos");
    eventBus.$off("archivoCargado");
    eventBus.$off("archivoNoValido");
    eventBus.$off("archivoProcesadoParaBatch");
  },
  computed: {
    cargaHabilitadaActiva() {
      console.log("this.fechaCargaHabilitada", this.fechaCargaHabilitada);

      if (!this.fechaCargaHabilitada) return false;
      const fechaInicioConvert = this.$moment(
        this.fechaCargaHabilitada.fechaInicio
      ).tz("America/Bogota");
      let fechaFinConvert = this.$moment(this.fechaCargaHabilitada.fechaFin).tz(
        "America/Bogota"
      );
      if (fechaFinConvert.format("HH:mm:ss") === "00:00:00") {
        fechaFinConvert = fechaFinConvert.endOf("day");
      }
      return this.horaActual.isBetween(
        fechaInicioConvert,
        fechaFinConvert,
        null,
        "[]"
      );
    },
    habilitarCarga() {
      if (!this.cargaHabilitadaActiva) return false;

      if (this.archivosCargados.length === 0) return false;

      const archivosCargadosVisibles = this.archivosCargados.filter(
        (archivoId) => {
          const itemIndex = archivoId - 1;
          return (
            this.itemsFiles[itemIndex] && this.itemsFiles[itemIndex].visible
          );
        }
      );

      return archivosCargadosVisibles.length > 0;
    },
    showInit() {
      return this.$route.query.showInit;
    },
    currentPeriod() {
      if (!this.periodos || this.periodos.length === 0) {
        return {
          anio: new Date().getFullYear(),
          mes: new Date().getMonth() + 1,
        };
      }

      if (this.selectedIdx < 0 || this.selectedIdx >= this.periodos.length) {
        return {
          anio: new Date().getFullYear(),
          mes: new Date().getMonth() + 1,
        };
      }

      const { Periodo } = this.periodos[this.selectedIdx];

      if (!Periodo) {
        return {
          anio: new Date().getFullYear(),
          mes: new Date().getMonth() + 1,
        };
      }

      const [anio, mes] = Periodo.split("-");

      return {
        anio: parseInt(anio),
        mes: parseInt(mes),
      };
    },
  },
  methods: {
    async HistorialretencionEnLaFuente() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "Persona/ListaPersonaRetencionEnLaFuenteArt/" + this.personaId,
        });
        let historialRetencion = res;
        console.log("retencion", historialRetencion);
        historialRetencion = historialRetencion.filter(
          (x) =>
            x.mes == this.currentPeriod.mes && x.anio == this.currentPeriod.anio
        );
        console.log("retencion", historialRetencion[0]);
        if (historialRetencion.length > 0) {
          this.articuloSeleccionado = historialRetencion[0].calculoArt;
        }
      } catch (error) {
        this.listaRetencionEnLaFuente = [];
        console.log("err", error);
      }
    },
    iniciarCuentaRegresiva() {
      // Limpiar intervalo anterior si existe
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }

      // Actualizar cuenta regresiva cada segundo
      this.countdownInterval = setInterval(() => {
        this.actualizarCuentaRegresiva();
      }, 1000);

      // Actualizar inmediatamente
      this.actualizarCuentaRegresiva();
    },
    actualizarCuentaRegresiva() {
      if (!this.fechaCargaHabilitada || !this.fechaCargaHabilitada.fechaFin) {
        this.tiempoRestante = null;
        return;
      }

      const fechaFin = this.$moment(this.fechaCargaHabilitada.fechaFin).tz(
        "America/Bogota"
      );
      const ahora = this.$moment().tz("America/Bogota");

      // Si la fecha de fin es 00:00:00, ajustar al final del día
      if (fechaFin.format("HH:mm:ss") === "00:00:00") {
        fechaFin.endOf("day");
      }

      const diferencia = fechaFin.diff(ahora);

      if (diferencia <= 0) {
        // Tiempo expirado
        this.tiempoRestante = null;
        return;
      }

      const duracion = this.$moment.duration(diferencia);

      this.tiempoRestante = {
        dias: Math.floor(duracion.asDays()),
        horas: duracion.hours(),
        minutos: duracion.minutes(),
        segundos: duracion.seconds(),
      };
    },
    async guardarRetencionEnLaFuente() {
      try {
        let dataRetencion = {
          PersonaId: this.personaRetencionEnLaFuente,
          Mes: this.currentPeriod.mes,
          Anio: this.currentPeriod.anio,
          CalculoArt: this.articuloSeleccionado,
        };
        await this.$store.dispatch("hl_post", {
          path: "Persona/CrearPersonaRetencionEnLaFuenteArt",
          data: dataRetencion,
        });
        this.$bvModal.hide("modal-retencion");
        Swal.fire(
          "¡Perfecto!",
          "La configuración de retención se guardó exitosamente.",
          "success"
        );
      } catch (error) {
        console.log("rror ", error);
        Swal.fire(
          "Error",
          "No se pudo guardar la configuración. Inténtalo de nuevo.",
          "error"
        );
      }
    },
    async retencionEnLaFuenteModal() {
      this.personaRetencionEnLaFuente = this.personaId;
      try {
        this.$bvModal.show("modal-retencion");
      } catch (error) {
        console.log("err", error);
      }
    },
    handleArchivosSubidos({ data, tipo }) {
      console.log(`Archivo ${tipo}:`, data);
      if (tipo === "subido") {
        this.archivosSubidos.push(data);
      } else if (tipo === "resubido") {
        this.archivosReSubidos.push(data);
      } else if (tipo === "error") {
        // Remover el archivo de la lista de cargados si hubo error
        this.archivosCargados = this.archivosCargados.filter(
          (id) => id !== data
        );
        console.log(`Archivo ${data} removido de la lista por error`);
      }
      this.processUploadsCombined();
    },
    handleArchivoCargado(data) {
      console.log("archivoCargado recibido", data);
      if (!this.archivosCargados.includes(data)) {
        this.archivosCargados.push(data);
      }
    },
    handleArchivoNoValido(id) {
      this.archivosCargados = this.archivosCargados.filter((x) => x !== id);
    },
    handleArchivoProcesadoParaBatch(data) {
      console.log("archivoProcesadoParaBatch recibido", data);
      this.archivosParaBatch.push(data);

      console.log("Archivos para batch:", this.archivosParaBatch.length);
      console.log("Archivos cargados:", this.archivosCargados.length);

      // Solo procesar si todos los archivos cargados han sido procesados
      if (this.archivosParaBatch.length === this.archivosCargados.length) {
        console.log(
          "Todos los archivos procesados, iniciando procesamiento en batch"
        );
        this.processUploadsCombined();
      }
    },
    cleanArchivosCargados() {
      this.archivosCargados = [];
      this.archivosSubidos = [];
      this.archivosReSubidos = [];
      this.archivosParaBatch = [];
      console.log("Archivos cargados limpiados debido a cambio de visibilidad");
    },
    processUploadsCombined() {
      if (this.timeout) clearTimeout(this.timeout);

      const totalUploaded =
        this.archivosSubidos.length + this.archivosReSubidos.length;
      const totalErrors = this.archivosCargados.length - totalUploaded;
      const expectedUploads = this.archivosCargados.length;

      const baseTimeout = 1000;
      const timeoutPerFile = 500;
      const dynamicTimeout = baseTimeout + expectedUploads * timeoutPerFile;

      this.timeout = setTimeout(async () => {
        console.log("Procesando archivos...");

        try {
          if (this.archivosParaBatch.length > 0) {
            await this.procesarArchivosEnBatch();
          } else if (totalUploaded > 0) {
            await this.getPeriodFiles(
              this.currentPeriod.anio,
              this.currentPeriod.mes
            );
          }

          this.archivosCargados = [];
          this.archivosSubidos = [];
          this.archivosReSubidos = [];
          this.archivosParaBatch = [];

          this.initializeShowDivs();
          core.index();

          this.waiting = false;

          if (expectedUploads > 0) {
            if (totalUploaded === expectedUploads) {
              this.showToast("success", "¡Documentos cargados exitosamente!");
            } else if (totalUploaded > 0) {
              this.showToast(
                "warning",
                `Se cargaron ${totalUploaded} de ${expectedUploads} documentos`
              );
            } else if (totalErrors === expectedUploads) {
              console.log(
                "Todos los archivos fueron saltados, no mostrando mensaje de error"
              );
            } else {
              this.showToast(
                "error",
                "No se pudieron cargar los documentos. Verifica que sean archivos PDF válidos."
              );
            }
          }
        } catch (error) {
          console.error("Error al procesar archivos:", error);
          this.waiting = false;
          this.showToast(
            "error",
            "Error al procesar los documentos. Inténtalo de nuevo."
          );
        }
      }, dynamicTimeout);
    },
    async procesarArchivosEnBatch() {
      try {
        console.log(
          "Procesando archivos en batch:",
          this.archivosParaBatch.length
        );

        const archivosParaEnviar = this.archivosParaBatch.map(
          (item) => item.archivoData
        );

        console.log("Archivos a enviar al batch:", archivosParaEnviar);

        const response = await this.$store.getters.fetchPut({
          path: "CDC/UploadArchivosBatch",
          data: archivosParaEnviar,
        });

        console.log("Respuesta del endpoint batch:", response);

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(
            errorData.error || "Error al procesar archivos en batch"
          );
        }

        const result = await response.json();
        console.log("Resultado del batch:", result);

        if (result.success) {
          console.log("Batch exitoso, actualizando UI con datos:", result.data);
          this.actualizarUIConDatosBatch(result.data);
        } else {
          throw new Error(
            result.errors?.join(", ") || "Error en el procesamiento en batch"
          );
        }
      } catch (error) {
        console.error("Error al procesar archivos en batch:", error);
        throw error;
      }
    },
    actualizarUIConDatosBatch(datosBatch) {
      console.log("Actualizando UI con datos:", datosBatch);

      datosBatch.forEach((resultado) => {
        let archivo, gestion;

        if (resultado.archivo && resultado.gestion) {
          archivo = resultado.archivo;
          gestion = resultado.gestion;
        } else if (resultado.id) {
          archivo = resultado;
          gestion = null;
        } else {
          console.warn("Formato de resultado no reconocido:", resultado);
          return;
        }

        const nombreBase = archivo.nombreArchivo
          .replace(/^_/, "")
          .replace(/\.[^/.]+$/, "");

        console.log("Buscando item con nombre:", nombreBase);
        console.log(
          "Items disponibles:",
          this.itemsFiles.map((item) => item.name)
        );

        const itemIndex = this.itemsFiles.findIndex(
          (item) => item.name === nombreBase
        );

        console.log("Item encontrado en índice:", itemIndex);

        if (itemIndex !== -1) {
          this.$set(this.itemsFiles[itemIndex], "id", archivo.id);
          this.$set(this.itemsFiles[itemIndex], "url", archivo.urlArchivo);
          this.$set(
            this.itemsFiles[itemIndex],
            "fechaSubida",
            archivo.fechaSubida
          );

          // Preservar la fecha de estado original si el archivo ya tenía una
          const fechaEstadoOriginal = this.itemsFiles[itemIndex].fechaEstado;

          if (gestion) {
            this.$set(this.itemsFiles[itemIndex], "estado", gestion.estado);
            // Solo actualizar fechaEstado si no es un resubido (EstadoGestion !== -1)
            // o si no había fecha de estado original
            if (gestion.estado !== -1 || !fechaEstadoOriginal) {
              this.$set(
                this.itemsFiles[itemIndex],
                "fechaEstado",
                gestion.fechaEstado
              );
            }
            // Si es un resubido (EstadoGestion === -1) y había fecha original, mantenerla
            else if (gestion.estado === -1 && fechaEstadoOriginal) {
              this.$set(
                this.itemsFiles[itemIndex],
                "fechaEstado",
                fechaEstadoOriginal
              );
            }
          } else {
            this.$set(this.itemsFiles[itemIndex], "estado", null);
            this.$set(this.itemsFiles[itemIndex], "fechaEstado", "");
          }

          console.log("Item actualizado:", this.itemsFiles[itemIndex]);
        } else {
          console.warn("No se encontró item para:", nombreBase);
        }
      });
    },
    updateSelectedIdx(value) {
      if (!value || !this.periodos || this.periodos.length === 0) {
        this.selectedIdx = 0;
        return;
      }

      const index = this.periodos.indexOf(value);
      this.selectedIdx = index >= 0 ? index : 0;

      this.showDivs = this.itemsFiles.reduce((acc, _, index) => {
        acc[index] = true;
        return acc;
      }, {});
    },
    async getFechaHabilitadaCargaSoportes(anio, mes) {
      try {
        const response = await this.$store.getters.fetchGet({
          path: `CDC/GetFecha/${this.persona.empresa.id}/${anio}/${mes}`,
        });
        if (response.ok) {
          const allData = await response.json();
          console.log(allData.data);
          if (allData.data) {
            const { isUploadCuentaCobro } = allData.data;

            const wasCuentaCobroVisible = this.itemsFiles[0].visible;

            this.itemsFiles[0].visible = !!isUploadCuentaCobro;

            if (wasCuentaCobroVisible !== this.itemsFiles[0].visible) {
              this.cleanArchivosCargados();
            }

            this.fechaCargaHabilitada = allData.data;
            console.log(
              "Fecha de carga habilitada:",
              this.fechaCargaHabilitada
            );

            // Reiniciar cuenta regresiva cuando cambie la fecha
            this.iniciarCuentaRegresiva();
          }
        }
      } catch (error) {
        console.error("Error en getFechaHabilitadaCargaSoportes:", error);
      }
    },
    async getIsOps() {
      try {
        const response = await this.$store.getters.fetchGet({
          path: `CDC/GetIsOps/${this.personaId}`,
        });
        if (response.ok) {
          const allData = await response.json();
          console.log(allData.data);
          return allData.data;
        }
      } catch (error) {
        console.error("Error en getIsOps:", error);
      }
    },
    showToast(type, message) {
      if (type == "success") {
        this.$toast.success(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
      }
      if (type == "error")
        this.$toast.error(message, {
          position: "top-center",
          timeout: 1492,
          closeOnClick: true,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
          draggable: false,
          draggablePercent: 0.41,
          showCloseButtonOnHover: false,
          hideProgressBar: true,
          closeButton: "button",
          icon: true,
          rtl: false,
        });
    },
    buildObjectCommentFile(archivoId) {
      return {
        personaId: this.personaId,
        archivoId: archivoId,
      };
    },
    gotoFile(url) {
      // Agregar timestamp para evitar cache del navegador
      const urlWithTimestamp = `${url}?t=${Date.now()}`;
      window.open(urlWithTimestamp);
    },
    initData(archivos) {
      archivos.forEach((archivo) => {
        const item = this.itemsFiles.find(
          (item) => `_${item.name}` === archivo.NombreArchivo.split(".")[0]
        );
        if (item) {
          this.$set(item, "id", archivo.ArchivoId);
          this.$set(item, "url", archivo.UrlArchivo);
          this.$set(item, "fechaSubida", archivo.FechaSubida);
          if (archivo.EstadoGestion != undefined) {
            this.$set(item, "estado", archivo.EstadoGestion);
            this.$set(item, "fechaEstado", archivo.FechaEstado);
          }
          if (archivo.Observaciones != undefined) {
            this.$set(item, "comments", archivo.Observaciones);
          }
        }
      });
    },
    async getPeriodos() {
      this.$isLoading(true);
      try {
        const response = await this.$store.getters.fetchGet({
          path: `CDC/GetPeriodos/${this.personaId}/${this.persona.empresa.id}`,
        });
        if (response.ok) {
          const allData = await response.json();
          if (allData.data && allData.data.length > 0) {
            this.periodos = allData.data;
            this.selectedValue = this.periodos[0];
            this.selectedIdx = 0;
            console.log("Periodos", this.periodos);

            await this.$nextTick();
            this.updateSelectedIdx(this.periodos[0]);
          } else {
            // Si no hay períodos, inicializar con valores por defecto
            this.periodos = [];
            this.selectedValue = null;
            this.selectedIdx = 0;
            console.log("No se encontraron períodos");
          }
        } else {
          // Si la respuesta no es exitosa, inicializar con valores por defecto
          this.periodos = [];
          this.selectedValue = null;
          this.selectedIdx = 0;
        }
        this.$isLoading(false);
      } catch (error) {
        console.error("Error al obtener el último período:", error);
        // En caso de error, inicializar con valores por defecto
        this.periodos = [];
        this.selectedValue = null;
        this.selectedIdx = 0;
        this.$isLoading(false);
        Swal.fire(
          "¡Error!",
          "Ha ocurrido un error al obtener los archivos de la cuenta de cobro.",
          "error"
        );
      }
    },
    async getPeriodFiles(anio, mes) {
      this.itemsFiles.forEach((item) => {
        this.$set(item, "id", "");
        this.$set(item, "url", "");
        this.$set(item, "fechaSubida", "");
        this.$set(item, "estado", null);
        this.$set(item, "fechaEstado", "");
        this.$set(item, "comments", []);
      });
      this.$isLoading(true);
      try {
        const response = await this.$store.getters.fetchGet({
          path: `CDC/GetPeriodFiles/${this.personaId}/${this.persona.empresa.id}/${anio}/${mes}`,
        });
        if (response.ok) {
          const allData = await response.json();
          if (allData.data.length > 0) {
            const archivos = JSON.parse(allData.data[0].Archivos);
            console.log("Archivos", archivos);
            this.itemsFiles.forEach((item) => {
              this.$set(item, "id", "");
              this.$set(item, "url", "");
              this.$set(item, "fechaSubida", "");
              this.$set(item, "estado", null);
              this.$set(item, "fechaEstado", "");
              this.$set(item, "comments", []);
            });

            this.archivosCargados = [];
            this.archivosReSubidos = [];
            this.archivosSubidos = [];
            if (archivos != null) {
              this.listaArchivos = archivos;
              this.initData(archivos);
            }
          }
        }
        this.$isLoading(false);
      } catch (error) {
        console.error("Error al obtener el último período:", error);
        this.$isLoading(false);
        Swal.fire(
          "Error",
          "No se pudieron cargar los documentos del período. Inténtalo de nuevo.",
          "error"
        );
      }
    },
    initializeShowDivs() {
      this.showDivs = this.itemsFiles.reduce((acc, _, index) => {
        acc[index] = true;
        return acc;
      }, {});
      this.activeIndexes = Object.keys(this.showDivs).map(Number);
    },
    toggle(index) {
      const idx = this.activeIndexes.indexOf(index);
      if (idx === -1) {
        this.activeIndexes.push(index);
      } else {
        this.activeIndexes.splice(idx, 1);
      }
    },
    isActive(index) {
      return this.activeIndexes.includes(index);
    },
    toggleComponent(index) {
      this.$set(this.showDivs, index, !this.showDivs[index]);
    },
    async guardarArchivos() {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: "Persona/ListaPersonaRetencionEnLaFuenteArt/" + this.personaId,
        });
        let historialRetencion = res;
        historialRetencion = historialRetencion.filter(
          (x) =>
            x.mes == this.currentPeriod.mes && x.anio == this.currentPeriod.anio
        );
        console.log("retencion", historialRetencion.length);
        if (historialRetencion.length == 0) {
          Swal.fire(
            "Configuración requerida",
            "Debes configurar la retención en la fuente antes de cargar documentos.",
            "info"
          );
          return;
        }

        if (!this.cargaHabilitadaActiva) {
          this.showToast(
            "error",
            "El período de carga no está habilitado en este momento"
          );
          return;
        }

        if (this.archivosCargados.length === 0) {
          this.showToast(
            "error",
            "Selecciona al menos un documento para cargar"
          );
          return;
        }

        this.waiting = true;

        eventBus.$emit("GuardandoArchivosCDC", this.archivosCargados);
      } catch (error) {
        console.error("Error en guardarArchivos:", error);
        this.waiting = false;
        Swal.fire(
          "Error",
          "No se pudo procesar la solicitud. Inténtalo de nuevo.",
          "error"
        );
      }
    },
  },
};
</script>

<style scoped type="scss">
@import url("https://unpkg.com/vue-select@3.20.2/dist/vue-select.css");
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s ease-in-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
.fade-enter-to,
.fade-leave {
  opacity: 1;
  transform: translateY(0);
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease-in-out;
  max-height: 1000px;
  overflow: hidden;
}
.slide-enter,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
  transform: translateY(-10px);
}
.slide-enter-to,
.slide-leave {
  max-height: 1000px;
  opacity: 1;
  transform: translateY(0);
}
.vs-table__footer {
  background: var(--body-bg) !important;
}
.vs__dropdown-toggle {
  min-height: 2.2rem;
  height: auto;
}
.accordion-title {
  display: flex;
  align-items: center;
  background-color: var(--gray-100);
  cursor: pointer;
  border: 1px solid var(--gray-100);
}
.accordion-title i {
  margin-right: 10px;
}
.accordion-content {
  padding: 10px;
}
.countdown-header {
  display: flex;
  align-items: center;
  background: var(--gray-100);
  border: 1px solid var(--border-color);
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.8;
  white-space: nowrap;
  flex-shrink: 0;
}

.countdown-text {
  font-weight: 600;
}
.fixed-bottom-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 2;
  background: var(--body-bg);
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid var(--border-color);
  overflow: hidden;
}

.fixed-bottom-button.border-animation {
  will-change: transform;
}

.border-animation span {
  pointer-events: none;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}

.border-animation span:nth-child(1) {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, transparent, #1a5cff);
  animation: animate1 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  .dark & {
    background: linear-gradient(to right, rgba(24, 25, 28, 0), #1a5cff);
  }
}

@keyframes animate1 {
  0% {
    transform: translateX(-100%) translateZ(0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(100%) translateZ(0);
    opacity: 0;
  }
}

.border-animation span:nth-child(2) {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 2px;
  background: linear-gradient(to bottom, transparent, #1a5cff);
  animation: animate2 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  animation-delay: 0.5s;
  .dark & {
    background: linear-gradient(to bottom, rgba(24, 25, 28, 0), #1a5cff);
  }
}

@keyframes animate2 {
  0% {
    transform: translateY(-100%) translateZ(0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateY(100%) translateZ(0);
    opacity: 0;
  }
}

.border-animation span:nth-child(3) {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(to left, transparent, #1a5cff);
  animation: animate3 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  .dark & {
    background: linear-gradient(to left, rgba(24, 25, 28, 0), #1a5cff);
  }
}

@keyframes animate3 {
  0% {
    transform: translateX(100%) translateZ(0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(-100%) translateZ(0);
    opacity: 0;
  }
}

.border-animation span:nth-child(4) {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 2px;
  background: linear-gradient(to top, transparent, #1a5cff);
  animation: animate4 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  animation-delay: 0.5s;
  .dark & {
    background: linear-gradient(to top, rgba(24, 25, 28, 0), #1a5cff);
  }
}

@keyframes animate4 {
  0% {
    transform: translateY(100%) translateZ(0);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateY(-100%) translateZ(0);
    opacity: 0;
  }
}

@media (max-width: 768px) {
  .countdown-header {
    font-size: 0.7rem;
    padding: 3px 6px;
  }
}
</style>
